import { http } from '@/lib/http'
import { WeatherForecast } from '@/models/WeatherForecast'

export class WeatherForecastRepository {
  async fetch(weatherAreaId: string): Promise<WeatherForecast> {
    const response = await http.post(`/weather/hour`, {
      weatherAreaId,
    })

    return response.data
  }
}
